{
  "background": {
    "primary": "#141d1f",
    "secondary": "#1b2628",
    "brand": {
      "primary": "#55dcf6",
      "secondary": "#135d6c"
    },
    "brandExtra": {
      "primary": "#9580ff",
      "secondary": "#301b98"
    },
    "inverse": "#ffffff",
    "static": {
      "dark": "#000000",
      "light": "#ffffff"
    },
    "success": {
      "primary": "#70f655",
      "secondary": "#2f5827"
    },
    "warning": {
      "primary": "#f6ab55",
      "secondary": "#6c4313"
    },
    "alert": {
      "primary": "#e8304f",
      "secondary": "#58272f"
    },
    "neutral": {
      "primary": "#607f85",
      "secondary": "#233134"
    }
  },
  "content": {
    "primary": "#e8eced",
    "secondary": "#b7c5c8",
    "tertiary": "#7b989d",
    "brand": {
      "primary": "#80eaff",
      "secondary": "#31cae8"
    },
    "brandExtra": {
      "primary": "#9580ff",
      "secondary": "#7055f6"
    },
    "inverse": "#000000",
    "static": {
      "light": "#ffffff",
      "dark": "#000000"
    },
    "success": {
      "primary": "#50e831",
      "secondary": "#368f24"
    },
    "warning": {
      "primary": "#f6ab55",
      "secondary": "#c37822"
    },
    "alert": {
      "primary": "#f65570",
      "secondary": "#c3223d"
    },
    "neutral": {
      "primary": "#99aeb2",
      "secondary": "#607f85"
    },
    "on": {
      "brand": "#000000",
      "brandExtra": "#ffffff",
      "success": "#000000",
      "warning": "#000000",
      "alert": "#ffffff",
      "neutral": "#000000"
    }
  },
  "border": {
    "primary": "#ffffff",
    "secondary": "#34474b",
    "brand": "#b2f2ff",
    "brandExtra": "#bfb2ff",
    "inverse": "rgba(20, 29, 31, 0.15)",
    "success": "#95ff80",
    "warning": "#ffc380",
    "alert": "#f65570",
    "neutral": "#607f85"
  },
  "overlay": {
    "mono": "rgba(178, 242, 255, 0.06)",
    "brand": "rgba(128, 234, 255, 0.2)",
    "brandExtra": "rgba(149, 128, 255, 0.3)",
    "success": "rgba(149, 255, 128, 0.2)",
    "warning": "rgba(255, 195, 128, 0.24)",
    "alert": "rgba(232, 48, 79, 0.32)",
    "neutral": "rgba(123, 152, 157, 0.28)",
    "monoHover": "rgba(178, 242, 255, 0.12)"
  },
  "layer": {
    "scrim": "rgba(0, 0, 0, 0.5)",
    "float": "rgba(0, 0, 0, 0.95)"
  },
  "control": {
    "brand": {
      "primary": {
        "bg": "#80eaff",
        "bgHover": "#b2f2ff",
        "bgPress": "#d6f8ff",
        "bgDisable": "rgba(52, 71, 75, 0.85)",
        "border": "#31cae8",
        "borderHover": "#55dcf6",
        "borderPress": "rgba(85, 220, 246, 0)",
        "borderDisable": "rgba(52, 71, 75, 0)"
      },
      "secondary": {
        "bg": "#135d6c",
        "bgHover": "#1b8398",
        "bgPress": "#22a8c3",
        "border": "#1b8398",
        "borderHover": "#22a8c3",
        "borderPress": "rgba(34, 168, 195, 0)"
      },
      "tertiary": {
        "bg": "rgba(11, 56, 65, 0)",
        "bgHover": "#0b3841",
        "bgPress": "#135d6c",
        "border": "rgba(11, 56, 65, 0)",
        "borderHover": "rgba(11, 56, 65, 0)",
        "borderPress": "rgba(19, 93, 108, 0)"
      },
      "text": {
        "primary": "#000000",
        "secondary": "#80eaff",
        "tertiary": "#31cae8",
        "disable": "rgba(232, 236, 237, 0.2)",
        "ghost": "#80eaff"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(128, 234, 255, 0.04)",
        "bgPress": "rgba(128, 234, 255, 0.08)",
        "border": "rgba(128, 234, 255, 0.16)",
        "borderHover": "rgba(128, 234, 255, 0.24)",
        "borderPress": "rgba(128, 234, 255, 0.16)"
      }
    },
    "mono": {
      "primary": {
        "bg": "#f4f5f6",
        "bgHover": "#e8eced",
        "bgPress": "#d7dee0",
        "border": "rgba(244, 245, 246, 0)",
        "borderHover": "rgba(232, 236, 237, 0)",
        "borderPress": "rgba(215, 222, 224, 0)"
      },
      "secondary": {
        "bg": "#233134",
        "bgHover": "#34474b",
        "bgPress": "#4a6368",
        "border": "#34474b",
        "borderHover": "#4a6368",
        "borderPress": "rgba(74, 99, 104, 0)"
      },
      "tertiary": {
        "bg": "rgba(35, 49, 52, 0)",
        "bgHover": "#233134",
        "bgPress": "#34474b",
        "border": "rgba(35, 49, 52, 0)",
        "borderHover": "rgba(35, 49, 52, 0)",
        "borderPress": "rgba(52, 71, 75, 0)"
      },
      "text": {
        "primary": "#000000",
        "secondary": "#e8eced",
        "tertiary": "#ffffff",
        "ghost": "#ffffff"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(255, 255, 255, 0.04)",
        "bgPress": "rgba(255, 255, 255, 0.08)",
        "border": "rgba(255, 255, 255, 0.16)",
        "borderHover": "rgba(255, 255, 255, 0.24)",
        "borderPress": "rgba(255, 255, 255, 0.16)"
      }
    },
    "brandExtra": {
      "primary": {
        "bg": "#7055f6",
        "bgHover": "#9580ff",
        "bgPress": "#bfb2ff",
        "border": "#9580ff",
        "borderHover": "#bfb2ff",
        "borderPress": "rgba(191, 178, 255, 0)"
      },
      "secondary": {
        "bg": "#301b98",
        "bgHover": "#3d22c3",
        "bgPress": "#5031e8",
        "border": "#3d22c3",
        "borderHover": "#5031e8",
        "borderPress": "rgba(80, 49, 232, 0)"
      },
      "tertiary": {
        "bg": "rgba(20, 11, 65, 0)",
        "bgHover": "#140b41",
        "bgPress": "#22136c",
        "border": "rgba(20, 11, 65, 0)",
        "borderHover": "rgba(20, 11, 65, 0)",
        "borderPress": "rgba(34, 19, 108, 0)"
      },
      "text": {
        "primary": "#ffffff",
        "secondary": "#ffffff",
        "tertiary": "#9580ff",
        "ghost": "#cef655"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(206, 246, 85, 0.04)",
        "bgPress": "rgba(206, 246, 85, 0.08)",
        "border": "rgba(206, 246, 85, 0.16)",
        "borderHover": "rgba(206, 246, 85, 0.24)",
        "borderPress": "rgba(206, 246, 85, 0.16)"
      }
    },
    "alert": {
      "bg": "#c3223d",
      "border": "#f65570",
      "primary": {
        "bg": "#e8304f",
        "bgHover": "#f65570",
        "bgPress": "#ff8095",
        "border": "#f65570",
        "borderHover": "#ff8095",
        "borderPress": "rgba(255, 128, 149, 0)"
      },
      "secondary": {
        "bg": "#8f2436",
        "bgHover": "#c3223d",
        "bgPress": "#e8304f",
        "border": "#c3223d",
        "borderHover": "#e8304f",
        "borderPress": "rgba(232, 48, 79, 0)"
      },
      "tertiary": {
        "bg": "rgba(49, 28, 31, 0)",
        "bgHover": "#311c1f",
        "bgPress": "#58272f",
        "border": "rgba(49, 28, 31, 0)",
        "borderHover": "rgba(49, 28, 31, 0)",
        "borderPress": "rgba(88, 39, 47, 0)"
      },
      "text": {
        "primary": "#ffffff",
        "secondary": "#ffffff",
        "tertiary": "#ff8095",
        "ghost": "#f67055"
      },
      "ghost": {
        "bg": "rgba(255, 255, 255, 0)",
        "bgHover": "rgba(246, 112, 85, 0.04)",
        "bgPress": "rgba(246, 112, 85, 0.08)",
        "border": "rgba(246, 112, 85, 0.16)",
        "borderHover": "rgba(246, 112, 85, 0.24)",
        "borderPress": "rgba(246, 112, 85, 0.16)"
      }
    },
    "input": {
      "bg": "rgba(178, 242, 255, 0.1)",
      "bgHover": "rgba(178, 242, 255, 0.15)",
      "bgDisable": "rgba(178, 242, 255, 0.25)",
      "border": "rgba(178, 242, 255, 0.1)",
      "borderHover": "rgba(178, 242, 255, 0.15)",
      "borderDisable": "rgba(178, 242, 255, 0)",
      "text": "#e8eced",
      "placeholder": "rgba(232, 236, 237, 0.56)",
      "textDisable": "rgba(232, 236, 237, 0.2)"
    },
    "focus": {
      "bg": "#141d1f",
      "border": "#31cae8"
    },
    "check": {
      "bg": "rgba(128, 234, 255, 0.1)",
      "bgHover": "rgba(128, 234, 255, 0.2)",
      "bgDisable": "rgba(52, 71, 75, 0.85)",
      "border": "#80eaff",
      "borderHover": "#b2f2ff",
      "borderDisable": "rgba(52, 71, 75, 0)",
      "icon": "#b2f2ff"
    },
    "faint": {
      "bg": "#233134",
      "bgHover": "#34474b",
      "border": "#34474b",
      "borderHover": "#4a6368"
    },
    "slider": {
      "bg": "#80eaff",
      "bgHover": "#b2f2ff",
      "bgDisable": "#34474b"
    },
    "switch": {
      "bg": "rgba(128, 234, 255, 0.1)",
      "bgHover": "rgba(178, 242, 255, 0.2)",
      "bgDisable": "rgba(52, 71, 75, 0.85)",
      "border": "#80eaff",
      "borderHover": "#b2f2ff",
      "borderDisable": "rgba(52, 71, 75, 0)"
    },
    "knob": {
      "bg": "#80eaff",
      "bgHover": "#b2f2ff",
      "bgActive": "#80eaff",
      "bgActiveHover": "#b2f2ff",
      "bgInactive": "#4a6368",
      "bgInactiveHover": "#607f85",
      "bgDisable": "#34474b"
    },
    "text": {
      "primary": "#e8eced",
      "disable": "rgba(232, 236, 237, 0.2)"
    },
    "link": {
      "primary": "#80eaff",
      "primaryHover": "#1b8398",
      "secondary": "#9580ff",
      "secondaryHover": "#5031e8"
    },
    "segmented": {
      "bg": "rgba(20, 29, 31, 0)",
      "bgHover": "#34474b",
      "bgActive": "rgba(128, 234, 255, 0.1)",
      "border": "rgba(52, 71, 75, 0)",
      "borderHover": "#4a6368",
      "borderActive": "#80eaff",
      "text": "#e8eced",
      "textDisable": "rgba(232, 236, 237, 0.2)"
    },
    "tagLabel": {
      "product": {
        "bg": "#d9ff66",
        "text": "#000000",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      },
      "rarity": {
        "bg": "#141d1f",
        "text": "#22a8c3"
      },
      "name": {
        "bg": "#233134",
        "text": "#b7c5c8"
      },
      "account": {
        "bg": "#9580ff",
        "text": "#000000",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      },
      "id": {
        "bg": "#34474b",
        "bgSeries": "#000000",
        "textSeries": "#b7c5c8",
        "textNumber": "#b7c5c8",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      },
      "subentity": {
        "bg": "#607f85",
        "text": "#000000"
      },
      "item": {
        "bg": "#80eaff",
        "text": "#000000",
        "textCompact": "rgba(255, 255, 255, 0.48)"
      }
    },
    "toast": {
      "bg": "#607f85"
    },
    "toggleButton": {
      "bg": "#233134",
      "bgHover": "#34474b",
      "bgActive": "rgba(128, 234, 255, 0.1)",
      "bgDisable": "rgba(52, 71, 75, 0.85)",
      "border": "#34474b",
      "borderHover": "#4a6368",
      "borderActive": "#80eaff",
      "borderDisable": "rgba(52, 71, 75, 0)",
      "text": "#e8eced",
      "textActive": "#e8eced",
      "textDisable": "rgba(232, 236, 237, 0.2)"
    },
    "appButton": {
      "bg": "#34474b",
      "bgHover": "#4b6368",
      "bgPress": "#607f85",
      "border": "#4b6368",
      "borderHover": "#607f85",
      "borderPress": "rgba(255, 255, 255, 0)",
      "text": "#b7c5c8",
      "textDisable": "rgba(232, 236, 237, 0.2)"
    }
  }
}
